module.exports = __webpack_public_path__ + "static/media/slider2.68621cc9.jpg";